export default function LoadSpriteSvgs() {
    // "touch" each sprite SVG file to trigger webpack processing
    function requireAll(r) {
        r.keys().forEach(r);
    }

    requireAll(
        require.context('Packages/Sites/GesagtGetan.Theme/Resources/Public/Assets/Svgs', true, /\.svg$/)
    );
}
